import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-journal-finder-tools-page',
  templateUrl: './journal-finder-tools-page.component.html',
  styleUrls: ['./journal-finder-tools-page.component.scss']
})
export class JournalFinderToolsPageComponent implements OnInit {

  constructor(
      private titleService: Title,
      private metaTagService: Meta,
      private LinkService: LinkService,
    ){
  
    }

  ngOnInit(): void {
    this.titleService.setTitle("期刊怎麼選？交給 Trinka，免費推薦最合適的期刊！");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 免費期刊查找工具，AI 幫你精準配對最適合投稿的期刊！" });
    this.metaTagService.updateTag({ property: 'og:title', content: "期刊怎麼選？交給 Trinka，免費推薦最合適的期刊！" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 免費期刊查找工具，AI 幫你精準配對最適合投稿的期刊！" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/journal-finder' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '期刊怎麼選？交給 Trinka，免費推薦最合適的期刊！' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka 免費期刊查找工具，AI 幫你精準配對最適合投稿的期刊！" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/journal-finder' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/journal-finder' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/journal-finder' });
 
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  sectionTitle = '如何找到適合您文章投稿的期刊？';
  stepDescription1 = '將您的稿件摘要複製貼上，Trinka 會分析內容，了解主要概念和重點方向。';
  stepDescription2 = 'Trinka會推薦一系列與您的研究主題密切相關且範圍相符的期刊。';
  stepDescription3 = '檢視建議的期刊，比較類似文章，並依地區（全球或特定區域）、影響因子範圍等條件進行篩選。';


  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
